import React, { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import './FilterTag.scss';
import { IFilter } from 'interfaces';
import { FilterType } from 'enums';

interface IFilterTagProps {
    filter: IFilter;
    onRemove: () => void;
}

export const FilterTag: FunctionComponent<IFilterTagProps> = ({ filter, onRemove }) => {
    const { t, i18n } = useTranslation();

    let typeLabel = ''
    switch (filter.type) {
        case FilterType.Firmware:
            typeLabel = t('filterTag.labels.firmware');
            break;
        case FilterType.Location:
            typeLabel = t('filterTag.labels.location');
            break;
        case FilterType.Manufacturer:
            typeLabel = t('filterTag.labels.manufacturer');
            break;
        case FilterType.Model:
            typeLabel = t('filterTag.labels.model');
            break;
        case FilterType.TestsStatus:
            typeLabel = t('filterTag.labels.testsStatus');
            break;
        default:
            console.log("ERROR: unsupported filter type for label: ", (filter as IFilter).type);
            break;
    }

    return (
        <li className="filterTag">
            <div className="filterTag_type">{typeLabel}</div>
            <div className="filterTag_label ellipsis" title={filter.label}>{filter.label || ' '}</div>
            <button
                type="button"
                className="filterTag_removeButton"
                onClick={onRemove}
                title={t('filterTag.removeButton')}
            >
                <div className="filterTag_removeIconCircle">
                    <FontAwesomeIcon icon="times" className="filterTag_removeIcon" />
                </div>
            </button>
        </li>
    );
};